import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
const e = React.createElement;
const baseUrl = process.env.REACT_APP_API_BASE_URL;
function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };
console.log('${baseUrl}/messages/create');
  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await fetch(`${baseUrl}/messages/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });
  
   if (!response.ok) {
    const errorData = await response.json();
    console.log("Error");
    throw new Error(errorData.error || 'Login failed');
  }
    console.log( response.json());
    setStatus('Message sent successfully!');
    setFormData({ name: '', contactNumber: '', message: '' });
  };

  return e('div', { className: 'page-content' },
    e('h1', null, 'Contact Us'),
    e('form', { onSubmit: handleSubmit, className: 'contact-form' },
      e('input', { type: 'text', name: 'name', placeholder: 'Your Name', value: formData.name, onChange: handleChange, required: true }),
      e('input', { type: 'text', name: 'contactNumber', placeholder: 'Your Contact Number', value: formData.contactNumber, onChange: handleChange, required: true }),
      e('textarea', { name: 'message', placeholder: 'Your Message', rows: '5', value: formData.message, onChange: handleChange, required: true }),
      e('button', { type: 'submit' }, 'Send Message')
    ),
    status ? e('p', { className: 'success-msg' }, status) : null
  );
}

export default Contact;